import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { MessageFilter } from "../../../../models/message-filter.model";
import {
  MessageStatus,
  MessageType,
  TrafficType
} from "../../../../enums/traffic-info-enums";
import { AuthService } from "../../../../services/auth.service";
import { UtilityService } from "../../../../services/utility.service";
import { MessageService } from "../../../../services/message.service";
import { DialogService } from "../../../../services/dialog.service";

@Component({
  selector: "app-filter",
  standalone: false,
  templateUrl: "./filter.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./filter.component.scss"]
})
export class FilterComponent implements OnInit {
  sv: any;
  locale = "sv";
  public showActive = true;
  public showPlanned = false;
  public showClosed = false;

  public showFilter = false;

  public showApp = true;
  public showTOT = true;

  public showPendeln = false;

  @Input() messageCount: number = 0;
  @Output() filterExpansionChange: EventEmitter<boolean> = new EventEmitter();
  @Output() filterChange: EventEmitter<MessageFilter> = new EventEmitter();
  @Output() sortChange: EventEmitter<{ orderType: string; revertedOrder: boolean }> = new EventEmitter();
  @Output() createMessageTrigger: EventEmitter<string> = new EventEmitter(); //emit ID = null

  filter = new MessageFilter(
    [MessageStatus.active],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    [MessageType.TI, MessageType.TOT]
  );
  
  sortingOptions = [
    {
      displayName: "Visas från (senast överst)",
      shortName: "Senast skapad",
      value: { orderType: "from", revertedOrder: true }
    },
    {
      displayName: "Senast uppdaterad (senast överst)",
      shortName: "Senast uppdaterad",
      value: { orderType: "lastUpdatedAt", revertedOrder: true }
    },
    {
      displayName: "Rubrik (A till Ö)",
      shortName: "Rubrik A–Ö",
      value: { orderType: "heading", revertedOrder: false },
    }
  ];

  selectedSort = this.sortingOptions[0];
  
  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private dialogService: DialogService
  ) {
    this.sv = UtilityService.svLocale;
  }

  ngOnInit() {
  }

  onChangeMessageStatus(statusToToggle) {
    this[statusToToggle] = !this[statusToToggle];
    this.filter.messageStatusesList = [];
    if (this.showActive) {
      this.filter.messageStatusesList.push(MessageStatus.active);
    }

    if (this.showClosed) {
      this.filter.messageStatusesList.push(MessageStatus.closed);
    }

    if (this.showPlanned) {
      this.filter.messageStatusesList.push(MessageStatus.planned);
    }

    this.onFilter();
  }

  onChangeMessageType(statusToToggle) {
    this[statusToToggle] = !this[statusToToggle];
    this.filter.messageTypeList = [];
    if (this.showApp) {
      this.filter.messageTypeList.push(MessageType.TI);
    }

    if (this.showTOT) {
      this.filter.messageTypeList.push(MessageType.TOT);
    }

    if (!this.showApp && !this.showTOT) {
      this.showApp = true;
      this.showTOT = true;
      this.filter.messageTypeList = [MessageType.TI, MessageType.TOT];
    }

    this.onFilter();
  }

  toggleExpansion() {
    this.showFilter = !this.showFilter;
    this.filterExpansionChange.emit(this.showFilter);
  }

  hasHiddenFilter() {
    return (
      this.filter.affects ||
      this.filter.createdOrUpdatedBy ||
      this.filter.from ||
      this.filter.to ||
      this.filter.heading ||
      this.filter.lastUpdatedAt ||
      this.filter.messageTypeList.length != 2
    );
  }

  isSortSelected(option: (typeof this.sortingOptions)[number]) {
    return this.selectedSort === option;
  }

  selectSort(option: (typeof this.sortingOptions)[number]) {
    if (this.selectedSort === option) {
      return;
    }

    this.selectedSort = option;
    this.sortChange.emit(option.value);
  }

  onFilter() {
    this.filterChange.emit(this.filter);
  }

  onDateChange(event, property) {
    this.filter[property] = event;
  }

  createMessage() {
    if (!this.messageService.hasChanges()) {
      this.messageService.clickNewMessage.emit('');
    } else {
      this.dialogService.unsavedChangesConfirmation().subscribe(result => {
        if (result) {
          this.messageService.clickNewMessage.emit('');
        }
      });
    }
  }

  isReadOnly() {
    return !this.authService.hasReadWriteGroups();
  }

  onClear(){
    this.filter = new MessageFilter(this.filter.messageStatusesList);
    this.filter.messageTypeList = [MessageType.TI, MessageType.TOT];
    this.showApp = true;
    this.showTOT = true;
    this.onFilter();
  }

  onEnter(){
    this.onFilter();
  }

  setToday(property: string) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.filter[property] = today;
    this.onDateChange(today, property);
  }

  clearDateField(property: string) {
    this.filter[property] = null;
    this.onDateChange(null, property);
  }
}
